import HighlightCard from "@components/HighlightCard"
import breakpoints from "@constants/breakpoints"
import React from "react"
import styled from "styled-components"

import { ContentfulContentBaseProps } from "../types"

const Container = styled.div`
  @media ${breakpoints.tablet} {
    margin: 106px 0;
  }

  @media ${breakpoints.laptop} {
    margin: 156px 0;
  }
`

interface ContentfulHighlightCardProps extends ContentfulContentBaseProps {}

const ContentfulHighlightCard: React.FC<ContentfulHighlightCardProps> = ({
  autoplayVideo,
  blockId,
  callToActionButtonLink,
  callToActionButtonText,
  callToActionLink,
  description,
  descriptionColor,
  fiftyPercentMedia,
  footer,
  footerColor,
  icon,
  image,
  imageGif,
  justification,
  largeTitle,
  mobileImage,
  mobileImageGif,
  mobileVideoUrl,
  muxMobileVideo,
  muxVideo,
  title,
  titleColor,
  videoThumbnail,
  videoUrl,
  wistiaEmbedCode,
  wistiaVideoId,
}) => {
  return (
    <Container id={blockId || undefined}>
      <HighlightCard
        autoplayVideo={autoplayVideo}
        callToActionButtonLink={callToActionButtonLink}
        callToActionButtonText={callToActionButtonText}
        callToActionLink={callToActionLink}
        description={description?.description}
        descriptionColor={descriptionColor}
        fiftyPercentMedia={fiftyPercentMedia}
        footer={footer}
        footerColor={footerColor}
        icon={icon?.file?.url}
        image={image?.file?.url}
        imageGif={imageGif?.file?.url}
        justification={justification}
        largeTitle={largeTitle}
        mobileImage={mobileImage?.file?.url}
        mobileImageGif={mobileImageGif?.file?.url}
        mobileVideoUrl={mobileVideoUrl}
        muxMobileVideo={muxMobileVideo}
        muxVideo={muxVideo}
        title={title}
        titleColor={titleColor}
        videoThumbnail={videoThumbnail?.file?.url}
        videoUrl={videoUrl}
        wistiaEmbedCode={wistiaEmbedCode}
        wistiaVideoId={wistiaVideoId}
      />
    </Container>
  )
}

export default ContentfulHighlightCard
